import { useTranslation } from 'react-i18next';

import { ErrorDeleteRetryDialog } from '$components/confirm-delete-dialog/error-delete-retry-dialog';

export interface DeleteNotificationRuleErrorDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onTryAgain: () => void;
}

export function DeleteNotificationRuleErrorDialog({
  isOpen,
  onClose,
  onTryAgain,
}: DeleteNotificationRuleErrorDialogProps) {
  const { t } = useTranslation();
  return (
    <ErrorDeleteRetryDialog
      isOpen={isOpen}
      onTryAgain={onTryAgain}
      onClose={onClose}
      title={t('errors.errorOccurred')}
      message={t('errors.unexpected')}
    />
  );
}
